import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0080 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="半日有休について。時間設定方法や一部社員に適用するには？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.05.12</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        継続的な労務提供を前提に事業運営を考える場合、心身共に健康的な状態であることが求められます。特に人手不足かつ繁忙を極める業種の場合はより重要な論点と言えます。そのためにも年次有給休暇は労働法制上唯一賃金保障されている「休暇」であることから労働者目線でも活用しやすいものです。今回は年次有給の中でも半日有休について解説します。
      </p>
      <img src="/images/column/details/c0080.jpg" alt="キンクラコラム画像80" />
      <div id="toc1">
        <h1>そもそもなぜ半日なのか？</h1>
      </div>
      <p>
        年次有給休暇の原則は暦日単位です。しかし、人手不足に陥っている企業の場合、労働者目線では丸一日休むことに躊躇いが出ることが容易に想像でき、
        <span>「半日であれば」有給休暇の請求をしやすい</span>
        という心理的な側面が窺われます。また、2019年4月1日の改正労働基準法により年10日以上有給休暇が付与される労働者に対し、当該付与日から1年以内に5日の取得が義務化されており、時間単位の場合は5日含めることはできないものの、半日有休の場合は「0.5日」として含めることが可能とされています。よって、企業目線でも法令違反回避に繋がる取得方法ということです。
      </p>

      <div id="toc2">
        <h1>午前と午後で所定労働時間が異なる場合での具体的な導入例</h1>
      </div>
      <p>
        例えば9時～18時が所定労働時間の企業の場合を検討します。12時から13時が休憩時間とすれば、午前中は3時間、午後が5時間となり、午前と午後で不均衡な状態となってしまいます。心理的にも午後に半日を取った方が「お得」ということになり、制度として疑問符が生じることでしょう。所定労働時間は当然企業によって異なるため、この場合の考え方を検討しておく必要があります。
        <br />
        <br />
        <span>
          半日単位の具体的な対応方法としては所定労働時間を半分に分けること
        </span>
        です。前述の例で「午後」に半休を取る場合、9時から12時まで勤務をし、12時から13時が休憩、13時から14時を再び勤務することで、この日は4時間勤務したことになります。14時以降は18時まで同じく4時間の労働時間であり、半休を取得することで均衡が取れることになります。また、休憩時間を前後の時間帯に調整することも考えられますが、労働基準法上、一部の業種を除き、休憩は一斉付与の原則があることから、もし、一斉に休憩を取得させない場合は労使協定の締結が必要です。
        <br />
        <br />
        所定労働時間に対しての不均衡を回避する目的であれば、
        <span>半休ではなく、時間単位での取得を認めることも選択肢の一つ</span>
        です。この場合、前提として労使協定の締結が必要であり、かつ締結したとしても時間単位で取得ができるのは年5日分が限度（半休はこのような制限はなし）となります。また、時間単位で取得した有給休暇は年5日の取得義務の日数には加算できないというデメリットがあります。半休と時間単位有給を併用させることも可能ですが、制度が煩雑となるため、
        <span>制度を何のために導入するのかをベースに導入する制度を検討</span>
        する事が適切です。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>半休を一部社員に適用する場合</h1>
      </div>
      <p>
        本来、年次有給休暇は1労働日以下に分割して付与する想定をしていません。よって、企業としては半日単位での請求を認める義務はありませんが、本来の年次有給休暇の取得を阻害しない範囲内で適正に運用されることを前提に労使双方において半日単位での取得が休暇の取得促進につながるのであれば問題ありません。また、半日単位はあくまで「労働者の希望」によることが前提となるため、全員が半休を希望するとは考え難く、むしろ一部の労働者が半休を希望するケースが一般的であることから、結果的に一部の労働者に適用させることが実務上は多いと考えられます。また、職種や時期を勘案し、
        <span>
          半休よりももはや暦日単位で取得すべきと判断する場合（明らかに疲弊している）、事業主側から積極的に本来の暦日単位での取得を勧奨することが適切
        </span>
        です。
      </p>

      <div id="toc4">
        <h1>フレックス制における半休など</h1>
      </div>
      <p>
        フレックスタイムタイム制においても有給休暇は付与対象ですし、暦日単位に限定されるわけではありません。フレックスタイム制は労働者が始業および終業の時刻を決定できる制度ではあるものの、精算期間全体の総労働時間を満たす必要があります。そこで、
        <span>
          実労働時間が総労働時間を下回る場合には労働時間を補う意味で半休を請求することで補填が可能
        </span>
        となります。
        <br />
        <br />
        ただし、注意点もあります。コアタイムなしのフレックスタイム制の場合、就業時間帯が特定されていませんので、どの時間帯にでも半休を当て込める余地があるため労務管理が非常に煩雑になることと、可能な限り有休を使い切るという意味で、
        <span>
          単に労働時間を増やす道具として濫用されることが起こり得ます。
        </span>
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        半休自体は多様な選択肢の中の一つとして今後も本来の暦日単位での取得を阻害しない範囲内で運用されることを前提に、選択肢の一つとして企業に残っていることが多いでしょう。ただし、一部の労働者のみしか理解していないという状態を回避する意味でも就業規則に明示をし、周知をすることが求められます。理由として休暇に関することは、労働基準法第89条に規定されているとおり、「絶対的必要記載事項」に該当することから、半休の制度的なルールについても就業規則へ定めが必要となるためです。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0080
